/**
 * API functions for interacting with notes
 */

import { emperor } from '~/services';

/**
 * Saves a note for a user profile
 * @param profileId - The ID of the profile
 * @param note - The note content
 * @param userId - The ID of the user creating the note
 */
export const saveProfileNote = async (profileId: string, note: string, userId: string) => {
  return await emperor.post('save-profile-note', { profileId, note, userId });
};

/**
 * Fetches notes for a user profile
 * @param profileId - The ID of the profile
 */
export const getProfileNotes = async (profileId: string) => {
  return await emperor.get(`profile-notes/${profileId}`);
};

/**
 * Saves a note for a building
 * @param buildingId - The ID of the building
 * @param note - The note content
 * @param userId - The ID of the user creating the note
 * @param pinned - Whether the note should be pinned (defaults to false)
 */
export const saveBuildingNote = async (buildingId: string, note: string, userId: string, pinned: boolean = false) => {
  return await emperor.post('save-building-note', { buildingId, note, userId, pinned });
};

/**
 * Fetches all notes for a building
 * @param buildingId - The ID of the building
 */
export const getBuildingNotes = async (buildingId: string) => {
  return await emperor.get(`get-building-notes/${buildingId}`);
};

/**
 * Toggles the pinned status of a building note
 * @param noteId - The ID of the note
 * @param pinned - The new pinned status
 */
export const toggleNotePinned = async (noteId: string, pinned: boolean) => {
  return await emperor.put(`toggle-note-pin/${noteId}`, { pinned });
};

/**
 * Saves a note for a flyer
 * @param buildingId - The ID of the building
 * @param note - The note content
 * @param userId - The ID of the user creating the note
 * @param pinned - Whether the note should be pinned (defaults to false)
 */
export const saveFlyerNote = async (buildingId: string, note: string, userId: string, pinned: boolean = false) => {
  return await emperor.post('save-flyer-note', { buildingId, note, userId, pinned });
};

/**
 * Fetches all notes for a flyer
 * @param buildingId - The ID of the building
 */
export const getFlyerNotes = async (buildingId: string) => {
  return await emperor.get(`get-flyer-notes/${buildingId}`);
};

/**
 * Toggles the pinned status of a flyer note
 * @param noteId - The ID of the note
 * @param pinned - The new pinned status
 */
export const toggleFlyerNotePinned = async (noteId: string, pinned: boolean) => {
  return await emperor.put(`toggle-flyer-note-pin/${noteId}`, { pinned });
};
